"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _Calendar = _interopRequireDefault(require("chaire-lib-frontend/lib/components/input/Calendar"));
var _moment = _interopRequireDefault(require("moment"));
var _ServiceLocator = _interopRequireDefault(require("chaire-lib-common/lib/utils/ServiceLocator"));
var _pages = require("chaire-lib-frontend/lib/components/pages");
var _LodashExtensions = require("chaire-lib-common/lib/utils/LodashExtensions");
var _utils = require("../../../services/ui/utils");
var _OctaviParameters = _interopRequireDefault(require("../../../services/ui/OctaviParameters"));
class CalendarPanel extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      filterSelected: _OctaviParameters.default.get('filterSelected', "FilterOne"),
      filters: _OctaviParameters.default.filters,
      dataSourceIds: _OctaviParameters.default.dataSourceIds
    };
    this.onValidityPeriodChange = this.onValidityPeriodChange.bind(this);
    this.updateDataSourceIds = this.updateDataSourceIds.bind(this);
    this.updateFilterSelection = this.updateFilterSelection.bind(this);
    this.updateFilter = this.updateFilter.bind(this);
  }
  componentDidMount() {
    _ServiceLocator.default.eventManager.on('taxi.dataSources.loaded', this.updateDataSourceIds);
    _ServiceLocator.default.eventManager.on('taxi.filter.filterSelection.update', this.updateFilterSelection);
    _ServiceLocator.default.eventManager.on('taxi.filter.init', this.updateFilter);
    _ServiceLocator.default.eventManager.on('taxi.filter.data.update', this.updateFilter);
  }
  componentWillUnmount() {
    _ServiceLocator.default.eventManager.off('taxi.dataSources.loaded', this.updateDataSourceIds);
    _ServiceLocator.default.eventManager.off('taxi.filter.filterSelection.update', this.updateFilterSelection);
    _ServiceLocator.default.eventManager.off('taxi.filter.init', this.updateFilter);
    _ServiceLocator.default.eventManager.off('taxi.filter.data.update', this.updateFilter);
  }
  updateDataSourceIds() {
    this.setState({
      dataSourceIds: _OctaviParameters.default.dataSourceIds
    });
  }
  updateFilterSelection() {
    this.setState({
      filterSelected: _OctaviParameters.default.filterSelected
    });
  }
  updateFilter() {
    this.setState({
      filters: _OctaviParameters.default.filters
    });
  }
  onValidityPeriodChange(startTime, endTime, filterName) {
    const filterIdx = (0, _utils.getFilterIdx)(this.state.filters, filterName);
    const start = (0, _moment.default)(startTime).format("YYYY-MM-DD");
    const newFilters = (0, _toConsumableArray2.default)(this.state.filters);
    newFilters[filterIdx]['calendarStartAt'] = start;
    if (endTime) {
      const end = (0, _moment.default)(endTime).format("YYYY-MM-DD");
      newFilters[filterIdx]['calendarEndAt'] = end;
    }
    this.setState({
      filters: newFilters
    });
    _OctaviParameters.default.filters = newFilters;
    _ServiceLocator.default.eventManager.emit('taxi.filter.data.update');
  }
  render() {
    const filterIdx = (0, _utils.getFilterIdx)(this.state.filters, this.state.filterSelected);
    if (this.state.dataSourceIds.length === 0 || this.state.filters.length === 0) {
      return /*#__PURE__*/_react.default.createElement(_pages.LoadingPage, null);
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "tr__form-input-container"
    }, /*#__PURE__*/_react.default.createElement(_Calendar.default, {
      id: `formFieldTaxiActivitesEditStartAndEndDate`,
      onChange: (start, end) => this.onValidityPeriodChange(start, end, this.state.filterSelected),
      dateFormat: "YYYY-MM-DD",
      startDate: this.state.filters[filterIdx]['calendarStartAt'],
      endDate: this.state.filters[filterIdx]['calendarEndAt'],
      language: this.props.i18n.language
    }));
  }
}
var _default = exports.default = (0, _reactI18next.withTranslation)()(CalendarPanel);